const Main = {

  'BOOKING-CREATE': {

  },
  'TRANSPLAN-CREATE': {
    'headerDetails': {
      type: 'Object',
      fields: {
        'NameCustomers': {
          required: true
        },
        'TrasportMode': {
          required: true
        },
        'ServiceType': {
          required: true,
        },
        'ShipmentsType': {
          required: true,
        },
        'ServiceLevel': {
          required: true,
        },
        'Incoterm': {
          required: true,
        },
        'FreightTermCode': {
          required: true,
        },
      }
    }
  }
};


export default Main;